import React, { useState } from 'react';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedPost, setSelectedPost] = useState(null);

  const navigateTo = (page) => {
    setSelectedPost(null);
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleViewPost = (post) => {
    setSelectedPost(post);
    setCurrentPage('blogPost');
  };

  let MainContent;
  switch (currentPage) {
    case 'home':
      MainContent = <HomePage navigateTo={navigateTo} />;
      break;
    case 'about':
      MainContent = <AboutPage />;
      break;
    case 'services':
      MainContent = <ServicesPage />;
      break;
    case 'blog':
      MainContent = <BlogPage onViewPost={handleViewPost} />;
      break;
    case 'blogPost':
      MainContent = <BlogPostPage post={selectedPost} navigateTo={navigateTo} />;
      break;
    case 'contact':
      MainContent = <ContactPage />;
      break;
    default:
      MainContent = <HomePage navigateTo={navigateTo} />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar currentPage={currentPage} navigateTo={navigateTo} />
      {MainContent}
      <Footer />
    </div>
  );
}

export default App; 